import { createContext, useContext } from "react";
import {
  BodypartType,
  MovementPatternType,
} from "@growth-machine-llc/stridist-api-client";
import { BaseLibraryFilterContextValues } from "../wrappers/router/coach/CoachLibraryLayout";

export const ALL_OPTIONS = "ALL" as const;

export type ALL_OPTIONS_TYPE = typeof ALL_OPTIONS;

export interface ExerciseListFilterContextValues
  extends BaseLibraryFilterContextValues {
  bodyparts: BodypartType[] | ALL_OPTIONS_TYPE;
  movementPatterns: MovementPatternType[] | ALL_OPTIONS_TYPE;
  tagIds: number[] | ALL_OPTIONS_TYPE;
  handleTagIdsChange: (tagIds?: number[], allOptionsSelected?: boolean) => void;
  handleBodypartChange: (bodyparts: BodypartType[]) => void;
  handleMovementPatternChange: (
    movementPatterns: MovementPatternType[],
  ) => void;
}

export const ExerciseListFilterContext = createContext<
  ExerciseListFilterContextValues | undefined
>(undefined);

export const useExerciseListFilterContext = () => {
  return useContext(ExerciseListFilterContext);
};
